<template>
    <div class="TutorialDialogue">
        <div class="td-container">
            
            <!-- <div class="td-close" @click="toggleTutorialDialogue()"/> -->

            <div id="mySwiper" class="swiper mp-gallery">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="data in tutorialData" :key="data.title">
                        <div class="td-slide">
                            <img class="td-slide-icon" :src="require('@/assets/' + data.icon)" alt="">
                            <div class="td-slide-title">{{ $t(data.title)}}</div>
                            <div class="td-slide-text">{{ $t(data.description)}}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="td-navigation">
                <div class="td-navigation-container">
                    <div id="swiper-pagination"/>
                    <div class="td-confirm">
                        <div class="td-confirm-button" @click="closeTutorialDialogue()">{{ $t('Verstanden')}} </div>
                    </div>
                </div>
            </div>

        </div>  
    </div>  
</template>

<script>
import Swiper , { Pagination } from 'swiper';
import 'swiper/swiper.min.css'
import 'swiper/modules/pagination/pagination.min.css'

export default {
    inject: ["toggleTutorialDialogue"],
    data: function () {
        return {
            firstTimeDialogueOpened: true,
            tutorialDialogueVisible: false,
            tutorialData: [
                {
                    title: "Den Showroom entdecken",
                    description: "Ziehen Sie nach links/rechts, um den Raum zu erkunden.",
                    icon: "flux360-Tutorial_scroll.svg"
                },
                {
                    title: "Vollbildmodus",
                    description: "Durch klicken auf dieses Icon wird der gesamte Showroom im Vollbildmodus dargestellt.",
                    icon: "Fullscreen.svg"
                },
                {
                    title: "Sprungpunkt ",
                    description: "Durch klicken auf dieses Icon wechseln Sie in den nächsten Raum",
                    icon: "Sprungpunkt.png"
                },
                {
                    title: "Lupe",
                    description: "Durch klicken auf dieses Icon eröffnen sich Ihnen tolle Zusatzinformationen in verschiedenen Formaten",
                    icon: "Lupe.png"
                },
                {
                    title: "Hilfe",
                    description: "Durch klicken auf dieses Icon erhalten Sie erneut diese Hilfestellung aller Funktion.",
                    icon: "Tutorial.svg"
                },
                // {
                //     title: "Zur Übersicht",
                //     description: "Durch klicken auf dieses Icon gelangen Sie zurück zur Übersicht aller Sprungpunkte.",
                //     icon: "Map.svg"
                // },
                // {
                //     title: "Kommunikation",
                //     description: "Durch klicken auf dieses Icon kann das Video und Audio Kommunkationsfenster geöffnet und verborgen werden.",
                //     icon: "Communication.svg"
                // },
                // {
                //     title: "Informations-Buttons",
                //     description: "Durch klicken auf dieses Icon eröffnen sich Ihnen tolle Zusatzinformationen in verschiedenen Formaten (z. B. PDF, Foto, Links oder Videos).",
                //     icon: "flux360-information-Button.svg"
                // },
                // {
                //     title: "360° View-Buttons",
                //     description: "Durch klicken auf dieses Icon eröffnet sich Ihnen ein 360° Viewer, welcher Ihnen eine Rundumsicht auf ein ausgewähltes Objekt bietet.",
                //     icon: "flux360-360-viewer-Button.svg"
                // }
            ]
        }
    }, 
    methods: {
        closeTutorialDialogue(){
            this.toggleTutorialDialogue();

            if(this.firstTimeDialogueOpened){
                this.firstTimeDialogueOpened = false;
                window.dispatchEvent(new CustomEvent("playVideoSphere"));
            }
        }
    },
    mounted(){
        setTimeout(() => {
            this.swiper = new Swiper('#mySwiper',{
                modules: [Pagination],
                spaceBetween: 50,
                direction: 'horizontal',
                clickable: true,
                mousewheel: true,
                observer: true,
                pagination: {
                    el: '#swiper-pagination',
                    clickable: true,
                },
            });
        }, 0); 
    }
}
</script>

<style>
.TutorialDialogue{
    width: 100%;
    height: 100%; 
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    background: rgba(0, 0, 0, 0.4);
}
.td-container{
    position: absolute;
    background: rgba(0, 0, 0, 0.9);
    width: 35%;
    height: 40%;
    min-width: 480px;
    min-height: 350px;
    overflow: hidden;
    border-radius: 2px;
}
.swiper{
    height: 100%;
    width: 100%;
}
.swiper-slide{
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}
.td-slide{
    height: 60%;
    width: 80%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-bottom: 10%;
}
.td-slide-icon{
    width: 30%;
    height: 30%;
    margin-bottom: 30px;
}
.td-slide-title{
    text-align: left;
    width: 100%;
    font-weight: bolder;
    font-size: 20px;
    margin-bottom: 5px;
}
.td-slide-text{
    text-align: left;
    align-self: flex-start;
    width: 100%;
    font-size: 16px;
}
.td-navigation{
    position: absolute;
    z-index: 2;
    bottom: 0;
    display: flex;
    width: 100%;
    justify-content: center;
    margin-bottom: 20px;
}
.td-navigation-container{
    width: 80%;
    display: flex;
    flex-direction: row;
    align-items: center;
}
#swiper-pagination{
    width: 50%;
}
.TutorialDialogue .swiper-pagination-bullet{
    width: 16px !important;
    height: 16px !important;
    background: transparent;
    border: 2px solid white;
    opacity: 1;
    transition: background .2s ease, border .2s ease;
}
.TutorialDialogue .swiper-pagination-bullet:first-child{
    margin-left: 0 !important;
}
.TutorialDialogue .swiper-pagination-bullet-active{
    background: white;
}
.td-confirm{
    width: 50%;
    display: flex;
    justify-content: flex-end;
}
.td-confirm-button{
    padding: 5px 20px;
    border: 2px solid white;
    color: white;
    font-size: 14px;
    cursor: pointer;
    border-radius: 5px;
    transition: background .2s ease, color .2s ease;
}
.td-confirm-button:hover{
    background: white;
    color: black;
}

.td-close{
    position: absolute;
    right: 20px;
    top: 20px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 3px solid white;
    cursor: pointer;
    z-index: 2;
    background: transparent;
    transition: background .2s ease;
}
.td-close:before, .td-close:after{
    position: absolute;
    top: 5px;
    left: 16px;
    content: ' ';
    height: 25px;
    width: 3px;
    background-color: white;
    transition: background .2s ease;
}
.td-close:before{
    transform: rotate(45deg);
}
.td-close:after{
    transform: rotate(-45deg);
}
.td-close:hover{
    background: white;
}
.td-close:hover:after, .td-close:hover::before{
    background: black;
}
</style>